import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";
import { ISendBetArgs } from "../store/interfaces";

@Injectable()
export class AddUserBetUseCase implements IUseCase<ISendBetArgs, void> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(data: ISendBetArgs): void {
       this.roundRepository.addUserBet(data.amount, data.betIndex, data.maxMultiplier);
    }
}
